import {
  Divider,
  Typography,
  Stack,
  MenuItem,
  Select,
  useTheme,
  Button,
  Popper,
  Paper,
  Grid,
  ListSubheader,
  List,
  IconButton,
  Box, OutlinedInput, DialogTitle, Dialog, DialogContent, DialogActions
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useMemo, useState } from "react";
// import IconButton from "../common/IconButton";
import { defaultGuid } from "../../../../common/utils";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";
import { assignPromptToProcess } from "../../../../store/slices/prompts";
import { locationsSelector } from "../../../../store/slices/location";
const getProcessName = (value) => {
  switch (value) {
    case 'Sentiments':
      return 'ProcessReviewsForTopics'

    case 'Response':
      return 'GenerateResponse'
    case 'Topics':
      return 'GenerateTopics'
    case 'Business':
      return 'Business'
    case 'Review Request':
      return 'GenerateRequestText'
    default:
      return ""
  }
}

const AssignPrompts = ({ open, handleClose, anchor, companyId }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { prompts } = useSelector(
    locationsSelector
  );
  const settingsPrompts = useMemo(() => prompts, [prompts])
  // const { companyId } = useSelector(reviewDataSelector);
  const [typeId, settypeId] = useState("");
  const [processId, setprocessId] = useState("");
  const [stepId, setStepId] = useState("");
  const [promptId, setPromptId] = useState("");
  const [dispatchData, setDispatchData] = useState([]);
  const [selectValueDisplay, setSelectValueDisplay] = useState({})

  const [errorParams, setErrorParams] = useState({
    typeId: false,
    processId: false,
    stepId: false,
    promptId: false,
  });
  const filterType = (data) => {
    const filteredData = _.filter(data, { companyId: typeId });
    return filteredData ?? [];
  };
  const settingsPromptsMemo = React.useMemo(
    () =>
      settingsPrompts && settingsPrompts.length > 0
        ? _.orderBy(settingsPrompts, "type", "asc")
        : [],
    [settingsPrompts, typeId]
  );

  const promptsProcessed = useMemo(() => _.filter(_.cloneDeep(settingsPromptsMemo), it => it.isProcessPrompt), [settingsPromptsMemo])

  useEffect(() => {
    if (_.size(promptsProcessed) > 0) {

      let obj = [];
      _.map(_.orderBy(promptsProcessed, 'companyId'), it => {
        it.processName = getProcessName(it.type)
        it.step = it.steps
        it.header = it.companyId === defaultGuid ? 'Global' : 'Company'

        setSelectValueDisplay(prev => ({ ...prev, [getProcessName(it.type) + it.steps]: it.companyId === defaultGuid ? 'Global' : 'Company' }))
        if (!_.find(obj, (i) => it.processName === i.processName && it.step === i.step))
          obj = [...obj, it]

        else obj = [..._.filter(obj, i => i.processName !== it.processName && i.step !== it.step), it]
        setDispatchData(obj)


      })
    }
  }, [promptsProcessed])

  const handleSelectValueDisplay = (process, step, header) => {
    const key = process + step
    setSelectValueDisplay(prev => ({ ...prev, [key]: header }))
  }
  const stepsList = useMemo(() => {
    return {
      ProcessReviewsForTopics: [
        {
          step: "TopicSentiment",
          processName: "ProcessReviewsForTopics",
          globalPromptId: "",
          companyPrompt: "",
          prompts: _.map(
            _.filter(settingsPromptsMemo, (a) => a.type === "Sentiments"),
            (a) => ({
              ...a,
              header: a.companyId === defaultGuid ? "Global" : "Company",
              processName: "ProcessReviewsForTopics",
              step: "TopicSentiment",
            })
          ),
        },
      ],
      GenerateResponse: [
        {
          step: "GenerateResponse",
          processName: "GenerateResponse",
          globalPromptId: "",
          companyPrompt: "",
          prompts: _.map(
            _.filter(settingsPromptsMemo, (a) => a.type === "Response"),
            (a) => ({
              ...a,
              header: a.companyId === defaultGuid ? "Global" : "Company",
              processName: "GenerateResponse",
              step: "GenerateResponse",
            })
          ),
        },
      ],
      Business: [
        {
          step: "Business",
          processName: "Business",
          globalPromptId: "",
          companyPrompt: "",
          prompts: _.map(
            _.filter(settingsPromptsMemo, (a) => a.type === "Business"),
            (a) => ({
              ...a,
              header: a.companyId === defaultGuid ? "Global" : "Company",
              processName: "Business",
              step: "Business",
            })
          ),
        },
      ],
      // GenerateTopics: [
      //   {
      //     step: "GetKeywords",
      //     processName: "GenerateTopics",
      //     globalPromptId: "",
      //     companyPrompt: "",
      //     prompts: _.map(
      //       _.filter(settingsPromptsMemo, (a) => a.type === "Topics"),
      //       (a) => ({
      //         ...a,
      //         header: a.companyId === defaultGuid ? "Global" : "Company",
      //         processName: "GenerateTopics",
      //         step: 'GetKeywords',
      //       })
      //     ),

      //   },
      //   {
      //     step: "CategorizeKeywords",
      //     processName: "GenerateTopics",
      //     globalPromptId: "",
      //     companyPrompt: "",
      //     prompts: _.map(
      //       _.filter(settingsPromptsMemo, (a) => a.type === "Topics"),
      //       (a) => ({
      //         ...a,
      //         header: a.companyId === defaultGuid ? "Global" : "Company",
      //         processName: "GenerateTopics",
      //         step: 'CategorizeKeywords',
      //       })
      //     ),
      //   },
      // ],
    };
  }, [settingsPromptsMemo]);

  const handleDispatchData = (obj) => {
    handleSelectValueDisplay(obj.processName, obj.step, obj.header)


    if (!_.find(dispatchData, { processName: obj.processName, step: obj.step }))
      setDispatchData((prev) => [...prev, obj]);
    else {

      setDispatchData(prev => [..._.filter(prev, i => !(i.processName === obj.processName && i.step === obj.step)), obj])
    }
  };
  //   const test = stepsList['ProcessReviewsForTopics'].reduce((listItems, cat) =>
  //    [
  //         ...listItems,
  //         <ListSubheader key={`subheader-${cat.name}`}>
  //             {cat.name}
  //         </ListSubheader>,
  //         ...(cat.prompts?.map((service, index) => (
  //             <MenuItem key={`item-${cat.name}-${index}`}>
  //                 {service.name}
  //             </MenuItem>
  //         )) || []),
  //     ]

  // , []);
  // console.log(test)

  const handleSelectList = (data, step) => {
    const transformedData = _.map(_.keys(_.groupBy(data, 'header')), type => ({ header: type, prompts: _.groupBy(data, 'header')[type] }))

    return transformedData?.reduce((listItems, cat) => {
      const catItems = [
        ...listItems,
        <ListSubheader sx={{ background: theme.palette.secondary.lighter }}>
          {cat?.header}
        </ListSubheader>,
        ...(cat?.prompts?.map((service, index) => {

          const isSelected = Boolean(_.find(dispatchData, it => it.promptId === service.promptId && it.step === step))
          // console.log(service.name, isSelected)
          return <MenuItem value={(service)} key={service?.promptId}
            selected={isSelected}
            sx={{ background: (isSelected ? theme.palette.primary.lighter : 'auto'), color: isSelected ? theme.palette.primary.main : 'auto' }}
          >
            <Stack sx={{ width: '100%' }} direction='row' spacing={2} justifyContent={'space-between'}><Typography>{service?.name}</Typography><Typography>{service?.llm}</Typography></Stack>
          </MenuItem>
        }) || []),
      ];
      return catItems;
    }, []);
  }
  const handleSave = () => {
    if (_.size(dispatchData) >= 1) {
      _.map(dispatchData, (a, i) => {
        let getPrompts = false
        const data = {
          companyId: a.companyId,
          processName: a.processName,
          step: a.step,
          promptId: a.promptId,
          subType: a.subType,
          selectedCompanyId: companyId,
        };
        if (i === (_.size(dispatchData) - 1)) {
          getPrompts = true
        }
        dispatch(assignPromptToProcess(data, getPrompts));
      })
      handleClose()
    }
  }
  const rendervalue = (value) => {
    return value.header
  }
  // console.log(stepsList, selectValueDisplay)
  return (
    <Dialog
      // placement="bottom"
      // disablePortal
      // anchorEl={anchor}
      maxWidth='md'
      fullWidth
      open={open}
      onClose={handleClose}
    >

      <DialogTitle
      // direction="row"
      // justifyContent={"space-between"}
      // spacing={6}
      // sx={{ pb: 2 }}
      >
        <Typography sx={{ alignSelf: "center" }} variant="h5">
          Assign Prompts
        </Typography>
        <IconButton shape="rounded" onClick={handleClose}
          sx={{
            position: "absolute",
            right: 12,
            top: 10,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider />
      <DialogContent>
        {/* <Stack spacing={2} sx={{py:1}}>
            <FormControl>
              <InputLabel>Type</InputLabel>
              <Select
                label="Type"
                value={typeId}
                error={errorParams.typeId}
                onBlur={() =>
                  setErrorParams((p) => ({ ...p, typeId: typeId === "" }))
                }
                onChange={(e) => settypeId(e.target.value)}
              >
                <MenuItem value={defaultGuid}>Global</MenuItem>
                <MenuItem value={companyId}>{"Company"}</MenuItem>
              </Select>
            </FormControl>
            <FormControl>
              <InputLabel>Process</InputLabel>
              <Select
                label="Process"
                value={processId}
                onBlur={() =>
                  setErrorParams((p) => ({ ...p, processId: processId === "" }))
                }
                error={errorParams.processId}
                onChange={(e) => setprocessId(e.target.value)}
                disabled={!typeId}
              >
                <MenuItem value={"ProcessReviewsForTopics"}>
                  {_.startCase("ProcessReviewsForTopics")}
                </MenuItem>
                <MenuItem value={"GenerateResponse"}>
                  {_.startCase("GenerateResponse")}
                </MenuItem>
                <MenuItem value={"GenerateTopics"}>
                  {_.startCase("GenerateTopics")}
                </MenuItem>
              </Select>
            </FormControl>
            <FormControl>
              <InputLabel>Step</InputLabel>
              <Select
                label="Step"
                value={stepId}
                error={errorParams.stepId}
                onBlur={() =>
                  setErrorParams((p) => ({ ...p, stepId: stepId === "" }))
                }
                onChange={(e) => setStepId(e.target.value)}
                disabled={!processId}
              >
                {_.map(stepsList[processId], (it) => (
                  <MenuItem value={it}>{_.startCase(it)}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl>
              <InputLabel>Prompts</InputLabel>
              <Select
                label="Prompts"
                value={promptId}
                error={errorParams.promptId}
                onBlur={() =>
                  setErrorParams((p) => ({ ...p, promptId: promptId === "" }))
                }
                onChange={(e) => setPromptId(e.target.value)}
                disabled={!stepId}
              >
                {settingsPromptsMemo?.map((it) => (
                  <MenuItem key={it.promptId} value={it.promptId}>
                    <ListItemText
                      primary={it.type + " - " + it.name}
                      sx={{
                        width: "100%",
                        // overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack> */}
        <Stack spacing={2} py={2} pr={2}>
          {_.map(_.keys(stepsList), (it) => {
            const groupedData = stepsList[it][0].prompts;
            { console.log(it, selectValueDisplay) }
            return (
              <Grid
                container
                direction={_.size(stepsList[it]) === 1 ? "row" : "column"}

                spacing={2}
                alignItems={_.size(stepsList[it]) === 1 ? "center" : ""}
                justifyContent={"space-between"}
              >
                <Grid item sx={{ p: 0 }} xs={3.5}>
                  <Typography variant={"subtitle1"} sx={{ justifySelf: "left" }}>
                    {_.startCase(it)}
                  </Typography>
                </Grid>
                {_.size(stepsList[it]) === 1 ? (
                  <Grid item xs={8.5} sx={{ position: 'relative', width: '100%', p: 0 }}>
                    <Select sx={{ width: '100%' }} fullWidth
                      value={_.find(dispatchData, { isProcessPrompt: true, header: 'Company' }) || _.find(dispatchData, { isProcessPrompt: true, header: 'Global' })}
                      defaultValue={_.find(dispatchData, { isProcessPrompt: true, header: 'Company' }) || _.find(dispatchData, { isProcessPrompt: true, header: 'Global' })}
                      renderValue={(option) => selectValueDisplay[it + stepsList[it][0]?.step]}
                      onChange={e => handleDispatchData(e.target.value)}
                    >{handleSelectList(groupedData, stepsList[it][0]?.step)}</Select>

                    {/* {<Typography sx={{ position: 'absolute', top: 28, left: 32 }}>{selectValueDisplay[it + stepsList[it][0]?.step]}</Typography>} */}

                  </Grid>
                ) : (

                  _.map(stepsList[it], (a, i) => {

                    const b = _.find(a.prompts, { isProcessPrompt: true, header: 'Company', step: a.step }) || _.find(a.prompts, { isProcessPrompt: true, header: 'Global', step: a.step })
                    return (
                      <Grid item xs={12} >
                        <Grid container spacing={2} alignItems={'center'}>
                          <Grid item xs={3.5} sx={{ p: 0 }}>
                            <Typography sx={{ ml: 3 }}>{a.step}</Typography>

                          </Grid>
                          <Grid item xs={8.5} sx={{ position: 'relative', width: '100%', p: 0 }}>

                            <Select fullWidth
                              defaultValue={_.find(dispatchData, { isProcessPrompt: true, header: 'Company', step: a.step }) || _.find(dispatchData, { isProcessPrompt: true, header: 'Global', step: a.step })}
                              value={_.find(dispatchData, { isProcessPrompt: true, header: 'Company', step: a.step }) || _.find(dispatchData, { isProcessPrompt: true, header: 'Global', step: a.step })}
                              renderValue={(option) => selectValueDisplay[it + a.step]} onChange={e => handleDispatchData(e.target.value)}>{handleSelectList(a.prompts, a.step)}</Select>
                            {/* <Typography sx={{ position: 'absolute', top: 28, left: 32 }}>{selectValueDisplay[it + a.step]}</Typography> */}
                          </Grid>
                        </Grid></Grid>
                    )
                  }
                  )

                )}
              </Grid>
            );
          })}
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions

        sx={{ justifyContent: "flex-start", py: '16px', px: '24px' }}
      >
        <Button variant="contained" onClick={handleSave} disabled={_.size(dispatchData) <= 0}>
          Save
        </Button>
        <Button variant="outlined" color="secondary" onClick={handleClose}>
          Close
        </Button>
      </DialogActions>

    </Dialog>
  );
};

export default AssignPrompts;
